/*
 *---------------------------------------------------
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 *---------------------------------------------------
 */
//standard libraries
import { useEffect, useState } from "react";
import { Canceler } from "axios";
import { useTranslation } from "react-i18next";

//custom libraries
import { useCSRValue, useSelectedStoreValue } from "../context";
import { useOnlineStoreResource } from "./rest";
import { FETCH_STORE_SUCCESS } from "../constants/actions";
import { localStorageHelper } from "../helpers/storageHelper";
import { CSR } from "../constants/common";
import { ConsoleSqlOutlined } from "@ant-design/icons";

/*INICIO: Importar archivo config.js dependiendo de las tiendas */
import { onlineStores } from "../config/difare/config";
// import { onlineStores } from "../config/hclcommercev8/config";
/*FIN: Importar archivo config.js dependiendo de las tiendas */

export const useStoreSelection = () => {
  const { t } = useTranslation();
  const { csr, dispatch } = useCSRValue();
  const { selectedStore, setSelectedStore } = useSelectedStoreValue();
  const [options, setOptions] = useState<any[]>([]);
  const [textFieldDisabled, setTextFieldDisabled] = useState<boolean>(true);
  const { getOnlineStoreForCsr, getOnlineStoreDescription } =
    useOnlineStoreResource();
  const cancels: any = { cancels: [] };

  const fetchStores = () => {
    /*INICIO - Ocultar llamada a /online-stores y evitar error 404 */
    //const [p, cancelers] = getOnlineStoreForCsr();
    //cancels.cancels = cancelers;
    /*FIN - Ocultar llamada a /online-stores y evitar error 404 */

    /*     p.then((res) => res.data.items)
      .then((onlineStores) => { */
    // reach here previous request finish.
    delete cancels.cancels;
    cancels.cancels = [];
    /*     const ps: Promise<any>[] = onlineStores.map((o: any) => {
      console.log(o);
      const [r, c] = getOnlineStoreDescription(o.id);
      cancels.cancels = cancels.cancels.concat(c);
      return r.then((res) => res.data.items);
    }); */
    /*     return Promise.all(ps).then((ds) => { */

    /*     const stores = onlineStores.map((o: any, i: number) => {
      o.descriptions = o;
      return o;
    }); */

    /* .filter((s: any) => {
              //only show headless store
              return (
                s.headlessStore && s.headlessStore.toLowerCase() === "true"
              );
            }) */ dispatch({
      type: FETCH_STORE_SUCCESS,
      payload: onlineStores,
    });
    /*     }); */
    /*   })
      .catch((e) => console.log(e)); */
  };

  const buildStoreOptions = (filter?: string) => {
    const { storeList } = csr;
    const _options = storeList.map((s: any) => {
      const option: any = { value: s.storeId };
      const secName: String = s.identifier;
      const des: any[] =
        s.description?.filter((d: any) => String(d.languageId)) || [];

      if (des.length > 0) {
        option.name = des[0].name;
      }
      if (!option.name) option.name = secName;

      return option;
    });
    if (filter) {
      setOptions(
        _options.filter((o: any) => {
          const name: string = o.name;
          return name.toLocaleLowerCase().includes(filter);
        })
      );
    } else {
      setOptions(_options);
      setTextFieldDisabled(false);
    }
  };

  const selectStore = (id: string) => {
    const { storeList } = csr;
    const selected = storeList.filter((s: any) => String(s.storeId) === id)[0];
    if (selected) {
      setSelectedStore(selected);
      localStorageHelper.set("CURRENT-STORE", selected);
    }
  };

  const validateOptionsChange = (): boolean => {
    return !options || !options.length;
  };

  useEffect(() => {
    return () => {
      cancels.cancels.forEach((cancel: Canceler) => {
        return cancel();
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!csr.storeList || csr.storeList[0] == null) {
      fetchStores();
    } else if (validateOptionsChange()) {
      buildStoreOptions();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [csr]);

  useEffect(() => {
    if (csr.userLoggedIn) {
      if (!selectedStore) {
        const savedStore = localStorageHelper.get("CURRENT-STORE");
        if (savedStore) {
          setSelectedStore(savedStore);
        }
      }
    } else {
      localStorageHelper.remove("CURRENT-STORE");
    }
  }, []);

  return {
    csr,
    selectStore,
    options,
    t,
    selectedStore,
    buildStoreOptions,
    textFieldDisabled,
  };
};
